import {MatrixReportResponseRaw} from "~src/interfaces/heatmap.interface";
import {ThunkFailAction, ThunkSuccessAction} from "~src/services/apiMiddleware";
import {Action} from "redux";
import {AxiosError} from "axios";

export enum fetchQuestionsMatrix {
  Request = 'FETCH_QUESTION_MATRIX_REQUEST',
  Success = 'FETCH_QUESTION_MATRIX_SUCCESS',
  Failed = 'FETCH_QUESTION_MATRIX_FAILED',
}

export interface FetchQuestionsMatrixSuccessAction extends ThunkSuccessAction<MatrixReportResponseRaw> {
  type: fetchQuestionsMatrix.Success;
}

export interface FetchQuestionsMatrixFailureAction extends ThunkFailAction<unknown> {
  type: fetchQuestionsMatrix.Failed;
}

export enum fetchTopicsMatrix {
  Request = 'FETCH_TOPIC_MATRIX_REQUEST',
  Success = 'FETCH_TOPIC_MATRIX_SUCCESS',
  Failed = 'FETCH_TOPIC_MATRIX_FAILED',
}

export interface FetchTopicsMatrixSuccessAction extends ThunkSuccessAction<MatrixReportResponseRaw> {
  type: fetchTopicsMatrix.Success;
}
export interface FetchTopicsMatrixFailureAction extends ThunkFailAction<unknown> {
  type: fetchTopicsMatrix.Failed;
}

export enum fetchOptionsOfAttr {
  Request = 'FETCH_COMPARE_ATTR_OPTIONS_REQUEST',
  Success = 'FETCH_COMPARE_ATTR_OPTIONS_SUCCESS',
  Failed = 'FETCH_COMPARE_ATTR_OPTIONS_FAILED',
}

export enum fetchSingleGroup {
  Request = 'FETCH_SINGLE_GROUP_REQUEST',
  Success = 'FETCH_SINGLE_GROUP_SUCCESS',
  Failed = 'FETCH_SINGLE_GROUP_FAILED',
}

export enum fetchSingleTopic {
  Request = 'FETCH_SINGLE_TOPIC_REQUEST',
  Success = 'FETCH_SINGLE_TOPIC_SUCCESS',
  Failed = 'FETCH_SINGLE_TOPIC_FAILED',
}

export const RESET_MATRIX = 'RESET_MATRIX';

export type ResetMatrixAction = {
  type: 'RESET_MATRIX'
}

export const SURVEY_CHANGE = 'SURVEY_CHANGE';

export enum fetchRecommendationsTypes {
  Request = 'FETCH_RECOMMENDATIONS_REQUEST',
  Success = 'FETCH_RECOMMENDATIONS_SUCCESS',
  Failed = 'FETCH_RECOMMENDATIONS_FAILED',
}

export interface FetchRecommendationsSuccessAction extends ThunkSuccessAction<MatrixReportResponseRaw> {
  type: fetchRecommendationsTypes.Success;
}
export interface FetchRecommendationsFailureAction extends ThunkFailAction<never> {
  type: fetchRecommendationsTypes.Failed;
}
export interface FetchRecommendationsRequestAction extends Action<fetchRecommendationsTypes> {
  type: fetchRecommendationsTypes.Request;
}
